export default "__VITE_ASSET__CdXd2bnk__"